import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DataTableComponent } from './fields/data-table/data-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ModalComponent } from './fields/modal/modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SearchFilterComponent } from './fields/search-filter/search-filter.component';
import { GeneralComponent } from './general/general/general.component';
import { LayoutComponent } from './layout/layout.component';
import { LaunchComponent } from './launch/launch.component';
import { MatIconModule } from '@angular/material/icon';
import { ColorPickerModule } from 'ngx-color-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule as EditorModule2 } from 'primeng/editor';
import { CommonsModule } from '../commons/commons.module';
import { ModalCssComponent } from './general/modal-css/modal-css.component';
import { NgxCodeJarComponent } from 'ngx-codejar';
import { MatExpansionModule } from '@angular/material/expansion';
import { ModalHeaderComponent } from './general/modal-header/modal-header.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from '../../infrastructure/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TemplateComponent } from './template/template.component';

@NgModule({
  declarations: [
    DataTableComponent,
    ModalComponent,
    SearchFilterComponent,
    GeneralComponent,
    LayoutComponent,
    LaunchComponent,
    ModalCssComponent,
    ModalHeaderComponent,
    TemplateComponent,
  ],
  exports: [
    DataTableComponent,
    ModalComponent,
    SearchFilterComponent,
    GeneralComponent,
    LayoutComponent,
    LaunchComponent,
    TemplateComponent
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
  imports: [
    NgxCodeJarComponent,
    CommonModule,
    NgxDatatableModule,
    MatIconModule,
    ColorPickerModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    NgSelectModule,
    CommonsModule,
    EditorModule2,
    MatExpansionModule,
    MatTooltipModule,
    TooltipModule.forRoot(),
    PipesModule,
    DragDropModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
